import type { Poste } from "models";
import { Endpoints } from "enums";
import { cometApiClient } from "./apiClients";

/**
 * Récupère tous les postes
 * @returns Array<Poste>
 */
async function getAll(): Promise<Array<Poste>> {
  const url = Endpoints.POSTES;
  return await cometApiClient.get<Array<Poste>, Array<Poste>>(url);
}

export const postesService = {
  getAll,
};
